import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CallDirection, CallHistory } from '@app/call-history/models/call-history.models';
import { CallHistoryService } from '@app/call-history/services/call-history.service';
import { AppConfigService } from '@app/core/services/app-config.service';
import { CallHistoryItemComponent } from '@app/shared/components/call-history-item/call-history-item.component';
import { ContactByIdPipe } from '@app/shared/pipes/contact-by-id.pipe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { NameCoinComponent } from '../name-coin/name-coin.component';

@UntilDestroy()
@Component({
  standalone: true,
  imports: [
    CommonModule,
    CallHistoryItemComponent,
    ContactByIdPipe,
    TranslateModule,
    MatIcon,
    MatIconButton,
    NameCoinComponent,
  ],
  selector: 'app-recent-calls-list',
  templateUrl: './recent-calls-list.component.html',
  styleUrls: ['./recent-calls-list.component.scss'],
})
export class RecentCallsListComponent implements OnChanges {
  private static readonly LIMIT = 50;

  @Input() searchTerm = '';

  @Output() callNumberSelected = new EventEmitter<string>();
  @Output() callNumber = new EventEmitter<string>();

  protected items: CallHistory[] = [];

  private callHistorySubscription?: Subscription;

  constructor(
    private callHistoryService: CallHistoryService,
    protected appConfigService: AppConfigService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.searchTerm) {
      this.subscribeToCallHistory();
    }
  }

  protected handleSelectCall(item: CallHistory) {
    const number = item.direction === CallDirection.incoming ? item.fromNumber : item.toNumber;

    this.callNumberSelected.emit(number);
  }

  protected handleCallNumber(item: CallHistory) {
    const number = item.direction === CallDirection.incoming ? item.fromNumber : item.toNumber;

    this.callNumber.emit(number);
  }

  private subscribeToCallHistory() {
    this.callHistorySubscription?.unsubscribe();

    const callHistory$ = this.searchTerm
      ? this.callHistoryService.getCallHistoryForContact(this.searchTerm, RecentCallsListComponent.LIMIT)
      : this.callHistoryService.getRecentCalls(RecentCallsListComponent.LIMIT);

    this.callHistorySubscription = callHistory$.pipe(untilDestroyed(this)).subscribe((items) => {
      this.items = items;
    });
  }
}
